<script setup lang="ts">

import { usePresentation } from '@/modules/Presentation/Types';
const presentation = usePresentation();

</script>

<template>

    <div class="bg-white h-full flex items-center">
        <Image src="/page-6b.jpg" class="w-full" />
        <a href="javascript:void(0)" 
            class="absolute w-[50vw] h-[36vw] left-0  cursor-pointer"
            @click="() => presentation.goto( 'calculator' )">
        </a>
    </div>

</template>